import { RxCustomerAPI, RxKongCustomerAPI, CustomerAPI, RxAuthAPI, AuthAPI, checkStatus, json } from '@driftt/dapper'
import queryString from 'query-string'

import config from 'config'

export const api = {
  fetchUser() {
    return RxCustomerAPI
      .get(`/users/me`)
      .checkStatus()
      .retryWithBackoff()
      .pluck('response')
  },
  checkUniqueEmail(email) {
    return RxKongCustomerAPI.head(`/users?${queryString.stringify({ email })}`)
  },
  updatePassword(userId, password) {
    return RxCustomerAPI
      .post(`/users/${userId}/password?clientId=${config.CLIENT_ID}`, { password })
      .checkStatus()
      .retryWithBackoff()
      .pluck('response')
  },
  updateUser(userId, updates) {
    return RxCustomerAPI
      .patch(`/users/${userId}`, updates)
      .checkStatus()
      .retryWithBackoff()
  },
  getLoginUrl(email) {
    const payload = { email, authClientId: config.SAML_CLIENT_ID, postLoginUrl: config.CUSTOMER_WEB_URL }
    return AuthAPI
      .post(`/sso/saml/login-url`, payload)
      .then(checkStatus)
      .then(json)
  },
  checkEmailIsSSOEnabled(email) {
    return RxAuthAPI
      .post(`/sso/saml/enabled`, { email })
      .checkStatus()
      .pluck('response')
  },

  fetchClearbitForEmail(email) {
    return RxCustomerAPI
      .get(`/enrichment/single/${email}`)
      .checkStatus()
  },

  acceptInvitation(password, token) {
    const data = new URLSearchParams()
    data.append('driftt_token', token)
    data.append('password', password)
    data.append('grant_type', config.ONE_TIME_TOKEN)
    data.append('client_id', config.CLIENT_ID)
    data.append('redirect_uri', config.CLIENT_ID_REDIRECT_URI)


    return RxCustomerAPI
      .post(`/oauth/token`, data.toString(), { raw: true, headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
      .checkStatus()
      .pluck('response')
  },

  findAssociatedDomain(email) {
    return RxKongCustomerAPI
      .post('/orgDomains/email/findOne', email)
      .checkStatus()
  },

  sendFindMyTeamVerificationEmail(email) {
    return RxKongCustomerAPI
      .post(`/findTeam/verifyEmail`, { email })
      .checkStatus()
  },

  setName(userId, updates) {
    return CustomerAPI
      .patch(`/users/${userId}`, updates)
      .then(checkStatus)
      .then(json)
  },

  setAvailability(userId, status) {
    const payload = [{
      operation: 'set',
      property: 'availability',
      value: status
    }]
    return CustomerAPI
      .patch(`/users/${userId}/patch`, payload)
      .catch(err => console.error(err))
  },

  updateUserProperties(userId, updates) {
    return RxCustomerAPI
      .patch(`/users/${userId}/properties`, updates)
      .checkStatus()
      .retryWithBackoff()
  },

  fetchEmailFromRelay(relayToken) {
    return RxCustomerAPI.get(`/relay?${queryString.stringify({ relayToken })}`)
      .checkStatus()
      .pluck('response')
  },

  setTimedVideoGate(orgId) {
    return RxCustomerAPI.post(`/gates/start_video_trial/${orgId}`)
      .checkStatus()
      .retryWithBackoff()
  },
  uploadUserAvatar(userId, file) {
    const data = new FormData()
    data.append('file', file)
  
    return CustomerAPI.post(`/users/${ userId }/avatar`, data, {
      file: true,
      headers: {
        'Content-Type' : 'multipart/form-data',
      }
    }).then(checkStatus).then(json)
  }
}
